// @flow
import * as React from 'react';
import Campaign from 'common/modules/campaign/domain/Campaign';
import CampaignMetrics from 'common/modules/campaign/domain/CampaignMetrics';
import Location from 'common/helpers/location';
import PrintingService from 'common/services/PrintingService';
import PrintButton from 'statsradio/components/PrintButton';

export const PRINT_CAMPAIGN_BUTTON_ID = 'print-campaign-button';

type Props = {
  campaign: Campaign;
  metrics: ?CampaignMetrics;
  label?: string;
}

export class PrintCampaignButton extends React.Component<Props> {

  print = () => {
    const { campaign, metrics } = this.props;

    const url = Location.buildUrlFor('campaign-printing');
    const message = {
      campaign: campaign && campaign.toJSON(),
      metrics: metrics,
    };

    PrintingService.printWindowWithData(url, 'CAMPAIGN_PRINTING_DATA', message);
  }

  render() {
    const { metrics, label } = this.props;

    return (
      <PrintButton
        disabled={!metrics}
        id={PRINT_CAMPAIGN_BUTTON_ID}
        onClick={this.print}
        label={label}
      />
    );
  }
}

export default PrintCampaignButton;



// WEBPACK FOOTER //
// ./src/statsradio/modules/campaigns/printing/PrintCampaignButton.js